import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Navbar";
import { Mail, Phone, MapPin } from "lucide-react";
import { CITY_LIST } from "../../data/cities";
import { useT } from "../../lib/i18n";
import { COMPANY } from "../../lib/company";

export default function Footer() {
  const t = useT();
  return (
    <footer className="bg-brand-dark text-white mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <Logo light />
          <p className="text-white/70 mt-5 leading-relaxed text-sm max-w-xs" data-testid="footer-tagline">
            {COMPANY.tagline_short}
          </p>
          <p className="text-white/50 mt-3 text-xs max-w-xs">
            Privat: enkeltlevering online · Erhverv: portal, labels, tracking, månedsfaktura.
          </p>
        </div>
        <div>
          <div className="kicker mb-4">{t("footer.services")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="text-white/80 hover:text-white" data-testid="footer-services">Services</Link></li>
            <li><Link to="/erhverv/faa-tilbud" className="text-white/80 hover:text-white" data-testid="footer-quote">Få tilbud</Link></li>
            <li><Link to="/erhverv" className="text-white/80 hover:text-white" data-testid="footer-business">Erhverv</Link></li>
            <li><Link to="/book" className="text-white/80 hover:text-white" data-testid="footer-book">Book levering</Link></li>
            <li><Link to="/track" className="text-white/80 hover:text-white" data-testid="footer-track">Spor pakke</Link></li>
            <li><Link to="/anmeldelser" className="text-white/80 hover:text-white" data-testid="footer-reviews">Anmeldelser</Link></li>
            <li><Link to="/bliv-chauffoer" className="text-white/80 hover:text-white" data-testid="footer-driver">Bliv chauffør</Link></li>
            <li><Link to="/vognmand-partner" className="text-white/80 hover:text-white" data-testid="footer-vognmand">Bliv vognmand</Link></li>
            <li><Link to="/find-pickup-point" className="text-white/80 hover:text-white" data-testid="footer-find-pickup">Find Pickup Point</Link></li>
            <li><Link to="/bliv-pakkeshop" className="text-white/80 hover:text-white" data-testid="footer-pakkeshop">Bliv Pickup Partner</Link></li>
            <li><Link to="/widget" className="text-white/80 hover:text-white" data-testid="footer-widget">Webshop Widget</Link></li>
          </ul>
        </div>
        <div>
          <div className="kicker mb-4">{t("footer.company")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/om-os" className="text-white/80 hover:text-white" data-testid="footer-about">Om EMA Kurer</Link></li>
            <li><Link to="/blog" className="text-white/80 hover:text-white" data-testid="footer-blog">Blog & guides</Link></li>
            <li><Link to="/kontakt" className="text-white/80 hover:text-white" data-testid="footer-contact">Kontakt</Link></li>
            <li><Link to="/handelsbetingelser" className="text-white/80 hover:text-white" data-testid="footer-terms">Handelsbetingelser (privat)</Link></li>
            <li><Link to="/erhvervsbetingelser" className="text-white/80 hover:text-white" data-testid="footer-business-terms">Erhvervsbetingelser (B2B)</Link></li>
            <li><Link to="/privatlivspolitik" className="text-white/80 hover:text-white" data-testid="footer-privacy">Privatlivspolitik</Link></li>
            <li><Link to="/cookie-politik" className="text-white/80 hover:text-white" data-testid="footer-cookie-policy">Cookie-politik</Link></li>
            <li><Link to="/tilgaengelighed" className="text-white/80 hover:text-white" data-testid="footer-accessibility">Tilgængelighed</Link></li>
            <li><Link to="/esg" className="text-white/80 hover:text-white" data-testid="footer-esg">ESG & bæredygtighed</Link></li>
            <li><Link to="/lukkedage" className="text-white/80 hover:text-white" data-testid="footer-closed">Lukkedage</Link></li>
            <li><Link to="/whistleblower" className="text-white/80 hover:text-white" data-testid="footer-whistleblower">Whistleblower</Link></li>
            <li>
              <button
                onClick={() => window.dispatchEvent(new CustomEvent("ema-open-cookie-settings"))}
                className="text-white/80 hover:text-white text-left"
                data-testid="footer-cookies"
              >
                Cookies
              </button>
            </li>
          </ul>
        </div>
        <div>
          <div className="kicker mb-4">{t("footer.contact")}</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-brand-red" /><a href={`tel:${COMPANY.phone_e164}`} data-testid="footer-phone">{COMPANY.phone}</a></li>
            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-brand-red" /><a href={`mailto:${COMPANY.email_general}`} data-testid="footer-email">{COMPANY.email_general}</a></li>
            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-brand-red" /><a href={`mailto:${COMPANY.email_billing}`} data-testid="footer-email-acct">{COMPANY.email_billing}</a></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-brand-red" /><span data-testid="footer-coverage">{COMPANY.coverage}</span></li>
            <li className="flex items-start gap-3"><span className="text-brand-red text-xs font-bold mt-1 w-4 text-center">§</span><span data-testid="footer-cvr">CVR {COMPANY.cvr}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-8" data-testid="footer-cities-block">
          <div className="kicker text-white/70 mb-4">{t("footer.cities")}</div>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
            {CITY_LIST.map((c) => (
              <Link key={c.slug} to={`/kurer-${c.slug}`} className="text-white/70 hover:text-white" data-testid={`footer-city-${c.slug}`}>
                Kurer {c.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {COMPANY.legal_name} · CVR {COMPANY.cvr} · emakurer.dk</div>
          <div className="tracking-[0.2em] uppercase">{t("footer.rights")}</div>
        </div>
      </div>
    </footer>
  );
}
